import { Injectable } from '@angular/core';
import { ApiCrudService } from './api-crud.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Link, CustomLinkItem } from '@app/models/custom-link';
import { map, tap } from 'rxjs/operators';
import { BaseConfigService, loadConf } from './config/base.service';

@Injectable({
  providedIn: 'root'
})
export class LinkService extends ApiCrudService<Link> {

  url = 'conf/links';

  linkItems$ = new BehaviorSubject<CustomLinkItem[]>(null);

  constructor(
    protected http: HttpClient,
    private baseConfigService: BaseConfigService
  ) {
    super();
  }

  getAll() {
    return super.getAll().pipe(
      map((res: any) => 'links' in res ? res.links : res)
    );
  }

  initLinks() {
    if (!this.linkItems$.value) {
      this.baseConfigService.getFirstConf$('custom-links').subscribe(conf => this.linkItems$.next(conf.content.links))
    }
  }

  updateLinks(links: CustomLinkItem[]): Observable<any> {
    return this.update({ links }).pipe(
      tap(_ => this.linkItems$.next(JSON.parse(JSON.stringify(links))))
    );
  }
}
